import { render } from "./treeBranches.vue?vue&type=template&id=1c9b88a9&scoped=true"
import script from "./treeBranches.vue?vue&type=script&lang=js"
export * from "./treeBranches.vue?vue&type=script&lang=js"

import "./treeBranches.vue?vue&type=style&index=0&id=1c9b88a9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9b88a9"]])

export default __exports__